import type { ExportJobAdapter } from "./types";

const FORMAT_LABELS: Record<string, string> = {
  pdf: "PDF",
  csv: "CSV",
  "csv+pdf": "CSV + PDF",
};

/** "Audit log · CSV" — names a job in its toast. */
export function exportJobLabel(subject: string, format: string): string {
  return `${subject} · ${FORMAT_LABELS[format] ?? format.toUpperCase()}`;
}

/** "12 profiles · PDF" */
export function profileExportLabel(count: number, format: string): string {
  const profiles = `${count.toLocaleString("en-US")} ${count === 1 ? "profile" : "profiles"}`;
  return exportJobLabel(profiles, format);
}

/** "It's taking longer than usual. We'll download it automatically when it's ready." */
export function slowExportJobCopy({
  readyAction,
}: Pick<ExportJobAdapter, "readyAction">): string {
  const next =
    readyAction === "download"
      ? "We'll download it automatically when it's ready."
      : "We'll let you know when it's ready.";
  return `It's taking longer than usual. ${next}`;
}
